<template>
  <div>
    <div
      v-if="registrationLinks.length === 1"
      class="btn"
      @click="clipboard(registrationLinks[0].url)"
    >
      Your Checkout Link
    </div>
    <div
      v-else
      class="links btn"
      @click="handleShowLinksClicked"
    >
      Your Checkout Links
      <div
        v-if="showLinks"
        class="links-dropdown"
        @mouseleave="showLinks = false"
      >
        <a
          v-for="(link, index) in registrationLinks"
          :key="index"
          href="javascript:;"
          @click="clipboard(link.url)"
        >
          <span v-html="link.name" /> <svg-vue icon="icons/copy" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      showLinks: false,
    };
  },
  computed: {
    ...mapGetters('stripeConnectDashboard', [
      'registrationLinks',
      'onlyRegistrationLink',
    ])
  },
  mounted() {
    this.fetchRegistrationLinks();
  },
  methods: {
    ...mapActions('stripeConnectDashboard', [
      'fetchRegistrationLinks',
    ]),
    clipboard(link) {
      if (!window.isSecureContext) {
        Swal.fire({
          icon: 'error',
          title: 'Insecure connection',
          html: 'Unable to write to clipboard, please copy and paste:<br>'+link,
        });
        return;
      }
      navigator.clipboard.writeText(link);
      Swal.fire('Copied to clipboard!');
    },
    handleShowLinksClicked() {
      this.showLinks = !this.showLinks;

      window.mixpanel('Merchant Center: View checkout links');
    }
  },
}
</script>

<style lang="scss" scoped>
.links {
  cursor: pointer;
  position: relative;
  background: #37B2A8;
  color: #fff;
  border: 1px solid var(--primary-color);
  border-radius: 12px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;

  svg {
    height: 16px;
    width: 16px;

    :deep(path) {
      stroke: var(--primary-color);
    }
  }

  .links-dropdown {
    position: absolute;
    top: 50px;
    right: 0;
    background: #FFFFFF;
    border: 1px solid #F0E9FF;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    white-space: nowrap;
    z-index: 10;

    a {
      padding: 8px 12px;
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 1.5rem;
      letter-spacing: -0.1px;
      text-align: left;
      cursor: pointer;
      color: #37B2A8;

      &:hover {
        background: #DFF5EE;
        border-radius: 8px;
      }
    }
  }
}

.btn span {
  color: var(--primary-font-color);
  line-height: 1rem;
  flex-grow: 1;
  padding-right: 5px;
}
</style>
